import { createElement } from 'react';
import ReactDOM from 'react-dom';

export interface ParseMatchedTextToElementType {
  key: string;
  parser: (content: string, index: number, ...extraData: any[]) => JSX.Element;
  // 当前 key 有几个值
  parseCount?: (count: number) => void;
}

// 将匹配文字解析成组件
// 如规则: #label#标签1# 会替换为 parser 的返回组件，并将 "标签1" 传递给 parser
export function parseMatchedTextToElement(
  rule: ParseMatchedTextToElementType | ParseMatchedTextToElementType[],
  content: string,
  tag = 'span',
  ...extraData: any[]
) {
  const parserConfig = (rule instanceof Array ? rule : [rule])
    .map((item) => ({
      rule: new RegExp(`#${item.key}#([^#]*)#`),
      parser: item.parser,
      parseCount: item.parseCount,
    }));
  const result: (string | JSX.Element)[] = [content];
  for (const item of parserConfig) {
    let pointer = 0; // 指针，指向当前正在解析result的第几项（解析过程result数组会变长）
    let resultIndex = 0; // 与 pointer 可能不相等
    let parseCount = 0; // 该类型总共有几个
    let match = null;
    while (pointer < result.length) {
      if (typeof result[pointer] !== 'string') {
        pointer++;
        resultIndex++;
        continue;
      }
      const matchSource = result[pointer] as string;
      match = matchSource.match(item.rule);
      if (!match) {
        pointer++;
        resultIndex++;
        continue;
      }
      result.splice(pointer, 1);
      if (match.index) {
        result.splice(pointer, 0, matchSource.substring(0, match.index));
        pointer++;
      }
      result.splice(pointer, 0, item.parser(match[1], resultIndex, ...extraData));
      parseCount++;
      pointer++;

      const endIndex = (match.index || 0) + match[0].length;
      if (endIndex < matchSource.length) {
        result.splice(pointer, 0, matchSource.substring(endIndex));
      }
      resultIndex++;
    }
    item.parseCount?.(parseCount);
  }
  return createElement(tag, {}, result);
}

// string 转 react 组件
export function stringToReactElement(str: string, {
  tag = 'div',
}: {
  tag?: string;
} = {}) {
  if (!str) {
    return str;
  }
  return createElement(tag, {
    dangerouslySetInnerHTML: {
      __html: str,
    },
  });
}

export const getHtml = (jsx: any) => {
  const el = document.createElement('div');
  ReactDOM.render(jsx, el);
  const html = el.innerHTML;
  el.remove();
  return html;
};
